import { FOXES_GIG_FOURTH_PACKAGE } from '../experimentsEnum';
import { inExperiment } from '..';

export default (abTests) => inExperiment(FOXES_GIG_FOURTH_PACKAGE, abTests);
